<template>
  <div class="ma-4">
    <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
    <v-sheet v-show="showSkeleton" class="pa-3 mr-4">
      <v-row v-for="item in 2" :key="item">
        <v-col cols="6">
          <v-skeleton-loader class="mx-auto" type="heading" />
        </v-col>
      </v-row>
    </v-sheet>
    <v-form ref="form" v-show="!showSkeleton">
      <div class="text-h4 mb-4">Atualizar Música de Espera - {{ description }}</div>
      <v-row align="baseline" dense>
        <v-col cols="4">
          <v-text-field
            dense
            v-model="form.description"
            :counter="30"
            label="Descrição"
            outlined
            :error-messages="descriptionErrors"
            @input="
              $v.form.description.$touch()
              form.description = $event.toUpperCase().trim()
            "
            @blur="$v.form.description.$touch()"
          />
        </v-col>
      </v-row>
      <v-row dense>
        <v-col cols="10">
          <v-file-input
            outlined
            dense
            show-size
            counter
            multiple
            accept="audio/wav"
            label="Escolha os áudios"
            v-model="form.files"
            prepend-icon="mdi-file-music"
          >
            <template v-slot:selection="{ text }">
              <v-chip small label color="grey">{{ text }}</v-chip>
            </template>
          </v-file-input>
        </v-col>
      </v-row>

      <v-divider class="ma-2" />

      <v-row>
        <v-col>
          <div class="text-h4">Áudios Atuais</div>
        </v-col>
      </v-row>

      <v-data-iterator :items="dataAudios" hide-default-footer>
        <template v-slot:default="props">
          <v-data-table
            dense
            :headers="headers"
            :items="props.items"
            hide-default-footer
            class="elevation-1"
            disable-pagination
          >
            <template v-slot:[`item.botoes`]="{ item }">
              <v-row dense align="center" justify="center">
                <PlayerAudio :file="playerAudio(item.dir)" color="primary" />
                <v-tooltip left>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      icon
                      small
                      dark
                      color="darkRed"
                      v-bind="attrs"
                      v-on="on"
                      :disabled="item.key === 0"
                      @click="deletar(item)"
                    >
                      <v-icon>{{ mostraIcone(item) }}</v-icon>
                    </v-btn>
                  </template>
                  <span>Remover</span>
                </v-tooltip>
              </v-row>
            </template>
          </v-data-table>
        </template>

        <template v-slot:footer>
          <v-row class="mt-2" align="center">
            <div class="ml-4 mt-2 grey--text">
              <div class="text-subtitle-1 text-left">Áudios da Classe: {{ dataAudios.length }}</div>
            </div>
          </v-row>
        </template>
      </v-data-iterator>
    </v-form>
    <FixedButtons @salvar="salvar" @cancelar="cancelar" :pararLoader="pararLoader" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { validationMixin } from 'vuelidate'

import Snackbar from '@/componentes/Snackbar'
import FixedButtons from '@/componentes/FixedButtons'
import { registerVuexModule } from '@/utils/vuexUtils'
import { hostname } from '@/utils/hostname'

import PlayerAudio from '../_components/PlayerAudio'
import { validateData, validateComputed } from '../_validates'
import musicaEmEsperaHttpService from '../_services/musicaEmEsperaHttpService'
import musicasEmEsperaStore from '../_store'

export default {
  name: 'CadastroAudio',
  props: {
    _id: String,
  },
  components: { Snackbar, FixedButtons, PlayerAudio },
  mixins: [validationMixin],
  data: () => ({
    description: '',
    text: '',
    snackbar: false,
    showSkeleton: true,
    headers: [
      {
        text: 'Descrição',
        value: 'description',
        align: 'left',
      },
      {
        text: 'Deletar',
        value: 'botoes',
        align: 'center',
        sortable: false,
      },
    ],
    form: {
      description: '',
      files: [],
      filesDelete: [],
    },
    dataAudios: [],
    pararLoader: {
      parar: false,
    },
  }),

  validations: {
    ...validateData,
  },

  computed: {
    ...validateComputed,
    ...mapGetters('atualizarMusicaEmEsperaModulePABXStore', ['getMusicaEmEspera']),
  },

  async created() {
    this.showSkeleton = true

    registerVuexModule(this.$store, 'atualizarMusicaEmEsperaModulePABXStore', musicasEmEsperaStore)

    await this.listarMusicaEmEspera(this._id)
    this.description = this.getMusicaEmEspera.description
    this.form.description = this.getMusicaEmEspera.description

    this.dataAudios = this.getMusicaEmEspera.audios.map((musicaEmEspera, key) => ({
      ...musicaEmEspera,
      key,
      deletado: false,
    }))

    this.showSkeleton = false
  },

  methods: {
    ...mapActions('atualizarMusicaEmEsperaModulePABXStore', ['listarMusicaEmEspera']),

    mostraIcone(item) {
      if (!item.deletado) {
        return 'mdi-checkbox-blank-circle-outline'
      }
      return 'mdi-checkbox-marked-circle-outline'
    },

    deletar(item) {
      item.deletado = !item.deletado

      if (item.deletado) {
        this.form.filesDelete.push({
          description: item.description,
          dir: item.dir,
        })
      } else {
        const indexFileDeleted = this.form.filesDelete.findIndex(file => file.description === item.description)

        if (indexFileDeleted !== -1) {
          this.form.filesDelete.splice(indexFileDeleted, 1)
        }
      }
    },

    async salvar() {
      this.pararLoader.parar = false

      this.$v.$touch()
      if (this.$v.$error) {
        this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
        return
      }
      try {
        await musicaEmEsperaHttpService.putMusicaEmEspera(this._id, this.form)
        this.$router.push({ name: 'Espera' })
      } catch (error) {
        let key = Object.keys(error.response.data)
        this.text = error.response.data[key[0]]
        this.snackbar = true
        this.pararLoader.parar = true
      }
    },
    cancelar() {
      this.$router.push({ name: 'Espera' })
    },
    playerAudio(audio) {
      const musicaEmEspera = audio.split('/')[audio.split('/').length - 1]
      const classe = audio.split('/')[audio.split('/').length - 2]
      return `https://${hostname()}/backend/asterisk/musica/play?musica=${musicaEmEspera}&classe=${classe}&token=${window.localStorage.getItem('pcm_access_token')}`
    },
  },
}
</script>
